module.exports = __webpack_public_path__ + "img/honor-nav-act.1ddd958f.png";